/* eslint-disable max-len */
import * as React from 'react';
import { IconProps } from '../types/componentTypes';

const MinusIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = 'black', ...props }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.6875 13.0703H18.1875C18.5625 13.0703 18.8828 12.75 18.8828 12.3672C18.8828 11.9844 18.5625 11.6719 18.1875 11.6719H6.6875C6.3125 11.6719 5.99219 11.9844 5.99219 12.3672C5.99219 12.75 6.3125 13.0703 6.6875 13.0703Z"
            fill={color}
        />
        <path
            d="M6.6875 13.0703H18.1875C18.5625 13.0703 18.8828 12.75 18.8828 12.3672C18.8828 11.9844 18.5625 11.6719 18.1875 11.6719H6.6875C6.3125 11.6719 5.99219 11.9844 5.99219 12.3672C5.99219 12.75 6.3125 13.0703 6.6875 13.0703Z"
            fill={color}
            fillOpacity="0.2"
        />
    </svg>
);

export default MinusIcon;
